export default __webpack_public_path__ + "static/media/43.6989851e.png";